import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import PlusContainer from './PlusContainer';
import '../TorontoFleets.css';

const AutzuPlus = () => (
  <Fragment>
    <PlusContainer appFormat={/plushtml/.test(window.location.href)} />
  </Fragment>
);

export default AutzuPlus;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPlus/index.js